import { Link } from "react-router-dom";
import { Logo } from "./Logo";

const cols = [
  {
    title: "Navigation",
    items: [
      { label: "Lernwelten", to: "/lernwelten" },
      { label: "So funktioniert VisualMA", to: "/#so-funktioniert", hash: true },
      { label: "Über VisualMA", to: "/ueber-visualma" },
      { label: "FAQ", to: "/faq" },
      { label: "Kontakt", to: "/kontakt" },
    ],
  },
  {
    title: "Rechtliches",
    items: [
      { label: "Impressum", to: "/impressum" },
      { label: "Datenschutz", to: "/datenschutz" },
      { label: "Nutzungsbedingungen", to: "/nutzungsbedingungen" },
      { label: "Widerruf & digitale Inhalte", to: "/widerruf" },
      { label: "Kontakt", to: "/kontakt" },
    ],
  },
  {
    title: "Social",
    items: [
      { label: "TikTok", to: "https://www.tiktok.com", external: true },
      { label: "Instagram", to: "https://www.instagram.com", external: true },
    ],
  },
];

export const Footer = () => (
  <footer className="border-t border-[color:var(--line)]" style={{ background: "var(--paper-deep)" }} data-testid="footer">
    <div className="max-w-6xl mx-auto px-5 lg:px-8 py-14">
      <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10">
        <div>
          <Logo />
          <p className="font-display italic text-lg mt-4 text-[color:var(--ink-muted)]">
            „Lernen darf schön sein."
          </p>
          <a
            href="mailto:hallo@visualma-lernwelten.de"
            className="inline-block mt-4 text-[14px] font-medium text-[color:var(--ink-muted)] hover:text-[color:var(--ink)] transition-colors underline underline-offset-4"
            data-testid="footer-contact-email"
          >
            hallo@visualma-lernwelten.de
          </a>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <p className="eyebrow-label mb-4">{c.title}</p>
            <ul className="space-y-2.5">
              {c.items.map((i) => (
                <li key={i.label}>
                  {i.external ? (
                    <a href={i.to} target="_blank" rel="noopener noreferrer" className="text-[14px] text-[color:var(--ink-muted)] hover:text-[color:var(--ink)] transition-colors" data-testid={`footer-link-${i.label.toLowerCase()}`}>
                      {i.label}
                    </a>
                  ) : i.hash ? (
                    <a href={i.to} className="text-[14px] text-[color:var(--ink-muted)] hover:text-[color:var(--ink)] transition-colors">
                      {i.label}
                    </a>
                  ) : (
                    <Link to={i.to} className="text-[14px] text-[color:var(--ink-muted)] hover:text-[color:var(--ink)] transition-colors" data-testid={`footer-link-${i.label.toLowerCase()}`}>
                      {i.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <p className="text-xs text-[color:var(--ink-muted)] mt-12 pt-6 border-t border-[color:var(--line)]">
        © {new Date().getFullYear()} VisualMA · Lernwelten für kleine Entdecker ab 2 Jahren
      </p>
    </div>
  </footer>
);
